<template>
  <div>
    <div v-if="gridData.totalItemCount > 0">
      <table
        id="order-history-grid"
        :class="
          viewBreakpointMoreThan('medium') ? 'b2b-grid b2b-grid--collapse mb-0 is-compact' : 'b2b-grid--collapse mb-0'
        "
      >
        <thead class="b2b-grid__header">
          <tr>
            <template v-for="(column, index) in headers">
              <th
                v-if="showColumn(column)"
                :key="index"
                class="b2b-grid__cell b2b-grid__head"
                :class="[column.cssClasses]"
                v-html="column.label"
              ></th>
            </template>
          </tr>
        </thead>

        <tbody>
          <!-- Each Row -->
          <template v-for="(row, rowIndex) in paginatedData">
            <order-item
              :key="row[idKey] + rowIndex"
              :row="row"
              :row-id="row[idKey]"
              :class="[{'bg-gray-02': (rowIndex + 1) % 2 === 0}, {'is-expanded': row.expanded}]"
              class="order-item"
            ></order-item>

            <transition :key="`child-${row[idKey]}`" name="fade">
              <order-item-details :row="row" :base-properties="baseProperties" />
            </transition>
          </template>
        </tbody>
      </table>
      <div v-if="cartToggle" class="grid-x grid-margin-x mb-5 mt-2">
        <div class="cell medium-6 large-8">
          <pagination
            v-if="gridData.pageCount > 1"
            ref="pagination"
            :page-number="gridData.pageIndex"
            :page-count="gridData.pageCount"
            @page-change="pageChange"
            @prev-page="prevPage"
            @next-page="nextPage"
          ></pagination>
        </div>
        <div class="cell medium-6 large-4">
          <div class="buttons buttons--right-for-md">
            <trek-link id="manage-allocated-items-link" button primary :href="linkManageAllocatedItems">
              <span v-html="bp('manageAllocatedItems')"></span>
            </trek-link>
          </div>
        </div>
      </div>
    </div>
    <pdl-callout v-else>
      <template #content>
        <span v-html="bp('searchNoResults')" />
      </template>
    </pdl-callout>
  </div>
</template>

<script>
import pagination from '../../../mixins/pagination';
import {mapState, mapGetters} from 'vuex';
import TrekLink from '@/components/TrekLink';
import viewSize from '@/mixins/view-size';

import OrderItem from '@/components/containers/my-account/OrderItem';
import OrderItemDetails from '@/components/containers/my-account/OrderItemDetails';
import Pagination from '@/components/Pagination';
import {PdlCallout} from '@pedal/pdl-callout';

export default {
  components: {
    OrderItem,
    OrderItemDetails,
    Pagination,
    TrekLink,
    PdlCallout,
  },
  mixins: [pagination, viewSize],

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      required: false,
      default: ACC.orderHistoryPageSize || 10,
    },

    gridData: {
      type: Object,
      default: () => {},
    },

    columns: {
      type: Array,
      default: () => [],
    },

    partSearchColumns: {
      type: Array,
      default: () => [],
    },

    childColumns: {
      type: Array,
      default: () => [],
    },

    idKey: {
      type: String,
      default: 'id',
    },

    childDataKey: {
      type: String,
      default: 'items',
    },
    orderStatus: {
      type: String,
      default: '',
    },
    linkManageAllocatedItems: {
      type: String,
      default: '',
    },
    isPartSearch: Boolean,
  },

  inject: ['container'],

  data() {
    return {};
  },

  computed: {
    listData() {
      return this.gridData.rows;
    },

    headers() {
      return this.isPartSearch ? this.partSearchColumns : this.columns;
    },

    ...mapState('backend', ['cartToggle']),
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  provide() {
    return {
      grid: this,
      container: this.container,
    };
  },

  methods: {
    pageChange(num) {
      this.container[this.orderStatus].pageIndex = num;
      this.container.fetchOrders(this.orderStatus);
    },

    showColumn(column) {
      // Don't show the Backorders column in Invoiced orders tab
      if (column.key === 'backOrders' && this.orderStatus === 'pastOrders') {
        return false;
      }
      if (column.key === 'orderTotal' && this.consumerFriendlyMode) {
        return false;
      }

      return true;
    },
  },
};
</script>
